// Queries
import receiptLogUnit from "./ReceiptLogUnitQuery.gql";

export const Query = {
    receiptLogUnit,
};
